import { VoteForViewData } from '@/generated/graphql';

export function computeVoteCounts(
  viewData: VoteForViewData | null | undefined,
) {
  return (viewData?.votes || []).reduce(
    (acc, vote) => {
      acc[vote.submissionId] = (acc[vote.submissionId] || 0) + vote.count;
      return acc;
    },
    {} as Record<string, number>,
  );
}
